/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompleteInventoryStockTakeDto as DigiworkMaitreDPosDtoInventoryStockTakeCompleteInventoryStockTakeDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/complete-inventory-stock-take-dto';
import { InventoryStockTakeDto as DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/inventory-stock-take-dto';

export interface CompleteInventoryStockTake$Params {
  inventoryId: string;
  stockTakeId: string;
      body?: DigiworkMaitreDPosDtoInventoryStockTakeCompleteInventoryStockTakeDto
}

export function completeInventoryStockTake(http: HttpClient, rootUrl: string, params: CompleteInventoryStockTake$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>> {
  const rb = new RequestBuilder(rootUrl, completeInventoryStockTake.PATH, 'post');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.path('stockTakeId', params.stockTakeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>;
    })
  );
}

completeInventoryStockTake.PATH = '/api/inventories/{inventoryId}/stock-takes/{stockTakeId}';
